import { FiEdit2 } from "react-icons/fi";
import { AiOutlineDelete } from "react-icons/ai";
function Action(props) {
  let editAction = props.editAction;
  let deleteAction = props.deleteAction;
  return (
    <div className="flex">
      <button
        className="flex p-1 rounded border  border-gray-100 bg-gray-100 hover:border-gray-300  text-gray-500 hover:text-gray-500 mr-2 title-tip title-tip-left"
        onClick={() => editAction()}
        message= 'Edit'
      >
        <FiEdit2 />
      </button>
      <button
        className="flex p-1 rounded  border border-gray-100 bg-red-100 hover:border-red-300  text-red-500 hover:text-red-500 mr-2 title-tip title-tip-left"
        onClick={() => deleteAction()}
        message='Delete'
      >
        <AiOutlineDelete />
      </button>

    </div>
  );
}
export default Action;
